// import Vue from 'vue'
// import { lqElementMixin, EventBus, lqPermissionMixin } from 'lq-form'
// import { isEqual } from 'lodash/core'
import IndirectInput from './../lq-form-element-maker/IndirectInput'

export default IndirectInput.extend({
    name: 'lq-v-text-field'
})